import { render, staticRenderFns } from "./CountryComponent.vue?vue&type=template&id=5d4611da"
import script from "./CountryComponent.vue?vue&type=script&lang=js"
export * from "./CountryComponent.vue?vue&type=script&lang=js"
import style0 from "./CountryComponent.vue?vue&type=style&index=0&id=5d4611da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports